import { render, staticRenderFns } from "./PU_details.vue?vue&type=template&id=634d125b&scoped=true&"
import script from "./PU_details.vue?vue&type=script&lang=js&"
export * from "./PU_details.vue?vue&type=script&lang=js&"
import style0 from "./PU_details.vue?vue&type=style&index=0&id=634d125b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634d125b",
  null
  
)

export default component.exports